import { jsx } from 'react/jsx-runtime';
import { styled } from 'styled-components';
import { ButtonIcon } from '../Button.js';
import { IconNavigational24OverflowMenu } from '@fabric-app/icons/svg';

const ButtonIconDotMenu = styled(ButtonIcon).attrs((props) => {
  return {
    ...props,
    variant: "bg-secondary",
    size: "default",
    children: /* @__PURE__ */ jsx(IconNavigational24OverflowMenu, {})
  };
}).withConfig({
  displayName: "ButtonIconDotMenu",
  componentId: "sc-6f8df257-0"
})([
  ``
]);

export { ButtonIconDotMenu };
//# sourceMappingURL=ButtonIconDotMenu.js.map
